/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon20Regular = forwardRef('NumberCircle07Icon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.837 6.01H7.131v1.267h3.977a18.449 18.449 0 0 0-1.853 3.254C8.728 11.714 8.39 12.87 8.238 14h1.684a13.991 13.991 0 0 1 1.062-3.695c.535-1.22 1.153-2.271 1.853-3.153V6.011Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 0 10 18 7.999 7.999 0 0 0 10 2Zm-6.499 8A6.499 6.499 0 1 1 16.5 10 6.499 6.499 0 0 1 3.5 10Z" })));
});
